import { createFileRoute, Link } from "@tanstack/react-router";
import { sanitizeHtml } from "@/lib/sanitize";
import { termsHtml } from "@/data/legalPages";
import { buildCanonical } from "@/lib/canonical-url";
import { PageHero } from "@/components/PageHero";
import pageCover from "@/assets/kupish/p-pogoji.webp";

export const Route = createFileRoute("/pogoji")({
  head: () => {
    const url = buildCanonical("/pogoji");
    const title = "Splošni pogoji poslovanja — kupish.si";
    const description =
      "Splošni pogoji poslovanja spletnega trgovskega središča kupish.si — pravila za kupce in prodajalce, naročila, dostava, plačila in reklamacije.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: Page,
});

function Page() {
  return (
    <article className="pb-24">
      <PageHero src={pageCover} alt="Splošni pogoji kupish.si — minimalističen 3D prikaz dokumentov">
        <Link to="/povzetek-pogojev" className="text-xs uppercase tracking-[0.18em] text-accent hover:underline">
          ← Povzetek pogojev
        </Link>
        <h1 className="font-serif text-4xl md:text-6xl mt-6 leading-[1.05] tracking-tight">
          Splošni <span className=" text-accent">pogoji</span> poslovanja
        </h1>
        <p className="mt-5 text-sm text-muted-foreground">
          Veljajo za uporabo spletnega nakupovalnega središča kupish.si.
        </p>
      </PageHero>

      <div className="mx-auto max-w-3xl px-6 mt-14 md:mt-20">
        <div className="article-prose" dangerouslySetInnerHTML={{ __html: sanitizeHtml(termsHtml) }} />
      </div>
    </article>
  );
}
